import React, { useState, useEffect } from "react";
import { Input } from "antd";
import FormatHelper from "../../../Helper/FormatHelper";

const InputSeperator = ({
  value,
  setValue,
  placeHolder,
  style,
  className,
  disabled,
  clearValue,
  onBlur,
}) => {
  const [inputValue, setInputValue] = useState("");

  function ToRial(str) {
    str = str.replace(/,/g, "");
    var objRegex = new RegExp("(-?[0-9]+)([0-9]{3})");

    while (objRegex.test(str)) {
      str = str.replace(objRegex, "$1,$2");
    }

    return str;
  }

  const handleChange = (e) => {
    let text = FormatHelper.toEnglishString(e.target.value.split(",").join(""));
    let regex = /^[0-9]+$|^[۰-۹]$/;
    if (text.length > 0 && regex.test(text) === true) {
      setInputValue(ToRial(FormatHelper.toEnglishString(e.target.value)));
    } else if (text.length === 0) {
      setInputValue(ToRial(FormatHelper.toEnglishString(e.target.value)));
    } else {
    }
  };

  useEffect(() => {
    setValue(FormatHelper.toEnglishString(inputValue.split(",").join("")));
  }, [inputValue]);

  useEffect(() => {
    if (clearValue && value.length === 0) {
      setInputValue("");
    }
  }, [value]);

  return (
    <Input
      className={className}
      disabled={disabled}
      onChange={handleChange}
      value={inputValue}
      lang="en"
      inputMode="tel"
      style={style}
      placeholder={placeHolder}
      onBlur={onBlur}
    />
  );
};

export default InputSeperator;
